import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { TelaCadastroModule } from 'src/app/components/tela-cadastro/tela-cadastro.module';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { DerrubaSessaoModule } from 'src/app/components/derruba-sessao/derruba-sessao.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: '', component: LoginComponent}
    ]),
    MatSnackBarModule,
    TelaCadastroModule,
    ModulosDeFormulario,
    DerrubaSessaoModule
  ],
  exports: [LoginComponent]
})
export class LoginModule { }
